import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import checkNetworkStatus from 'utils/functions/checkNetworkStatus';
import {Button, Modal} from 'letrus-ui';
import styles from './QuestionnaireFinishModal.module.scss';

export interface QuestionnaireFinishModalProps {
  id: string;
  onClick(): void;
  hasNextStep?: boolean;
  isLastLearningPathStep?: boolean;
  isLoading?: boolean;
}

const contentVariants = {
  lastLearningPathStep: {
    title: 'Uhull! Trilha concluída.',
    subtitle: 'Você chegou ao final desta trilha, parabéns!',
    button: 'Última etapa',
  },
  singleQuestionnaire: {
    title: 'Uhull! Etapa concluida.',
    subtitle: 'Que tal continuar praticando suas habilidades?',
    button: 'Próxima etapa',
  },
};

function QuestionnaireFinishModal({
  id,
  onClick,
  hasNextStep = true,
  isLastLearningPathStep = false,
  isLoading = false,
}: QuestionnaireFinishModalProps) {
  const [networkStatus, setNetworkStatus] = useState('online');

  const navigate = useNavigate();

  const content = isLastLearningPathStep
    ? contentVariants.lastLearningPathStep
    : contentVariants.singleQuestionnaire;

  useEffect(() => {
    checkNetworkStatus({
      onlineCallback: () => {
        setNetworkStatus('online');
      },
      offlineCallback: () => {
        setNetworkStatus('offline');
      },
    });
  }, []);

  return (
    <Modal closeButton id={id} className={styles.modal}>
      <div className={styles.wrapper} data-testid="questionnaire-finish-modal">
        <FontAwesomeIcon
          size="4x"
          icon="circle-check"
          className={styles.icon}
        />

        <div className={styles.content}>
          <h3>{content.title}</h3>

          <p>{content.subtitle}</p>
        </div>

        {hasNextStep && (
          <Button
            onClick={onClick}
            variant="primary"
            loading={isLoading}
            disabled={isLoading}
          >
            {content.button}
          </Button>
        )}
        <Button onClick={() => navigate('/')} variant="secondary">
          Ir para página inicial
        </Button>

        {networkStatus === 'offline' && (
          <p className={styles.offlineWarning} data-testid="offlineWarning">
            <b>Lembre-se: </b>
            você concluiu esse passo sem conexão com a <br /> internet - é
            necessário ficar online antes do prazo de terminar!
          </p>
        )}
      </div>
    </Modal>
  );
}

export default QuestionnaireFinishModal;
